import Axios from 'axios'
import router from '@/router'

export default Object.freeze({
  async uploadFile(file) {
    try {
      const formData = new FormData()
      formData.append('file', file)

      const response = await Axios.post('/api/file/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      if (response.code === 'session_timeout' && response.loginUrl) {
        router.push(response.loginUrl)
      } else if (response.data?.data) {
        return response.data.data
      }
      throw new Error(response.data?.errmsg ?? '')
    } catch (error) {
      if (error?.response?.data?.errmsg?.length > 0) {
        return new Error(error.response.data.errmsg)
      }
      return error
    }
  },
})
